import { i18n } from 'i18n';

export interface StopeNotePageParams {
  projectId: string;
  stopeId: string;
}

export const ROUTE_PARAM_IDENTIFIER = ':projectId';
export const STOPE_PARAM_IDENTIFIER = ':stopeId';

export const ROUTE_PATH = `/projects/${ROUTE_PARAM_IDENTIFIER}/overview/stopes/${STOPE_PARAM_IDENTIFIER}/note`;
export const TITLE = i18n._('Pour Note');
